import { SidebarContext } from "core/contexts/sidebar/sidebar";
import { filterSubModels } from "core/lib/utils";
import { useAppDispatch, useAppSelector } from "core/store/reduxStore";
import { useContext, useEffect, useState } from "react";
import FilteredItems from "./filteredItems";
import { useParams } from "react-router-dom";
import { setHeader, setBreadCrumbs } from "core/store/shared/header";
import { t } from "i18next";
import { HomeContainer } from "./home.styled";
import { useAppTheme } from "core/contexts/theme/theme";
import { otherRoutes, sidebarData } from "core/contexts/sidebar/sidebarData";
import { filterSidebarByProviders } from "core/utils/providerFilter";

interface ExpandedSideBarAreaProps {
  isLandingPage?: boolean;
}

function ExpandedSideBarArea({
  isLandingPage = false,
}: ExpandedSideBarAreaProps) {
  console.log("ExpandedSideBarArea - isLandingPage:", isLandingPage);
  const { modelData } = useContext(SidebarContext);
  const { name } = useParams<{ name: string }>();
  const { apptheme } = useAppTheme();

  const [targetSidebarObjects, setTargetSidebarObjects] = useState<any[]>([]);
  const dispatch = useAppDispatch();

  function extractDisplayText(obj: any, targetSidebarObjects: any = []) {
    if (obj?.sidebarProps?.displayText) {
      targetSidebarObjects.push(obj);
    }

    if (obj?.children) {
      obj.children.forEach((child) =>
        extractDisplayText(child, targetSidebarObjects)
      );
    }

    return targetSidebarObjects;
  }

  function findParentDisplayText(modelData, childDisplayText) {
    for (const parent of modelData) {
      const match = searchChild(parent, childDisplayText);
      if (match) return match;
    }
    return null;
  }

  function searchChild(node, childDisplayText) {
    if (!node || !node.children) return null;

    for (const child of node.children) {
      const displayText = child.sidebarProps?.displayText;

      if (displayText?.toLowerCase() === childDisplayText.toLowerCase()) {
        if ("showRawText" in node.sidebarProps === false) {
          const response = {
            displayText: t(`SIDEBAR.${node.sidebarProps?.displayText}`),
            path: node.path,
          };
          return response;
        } else {
          return {
            displayText: node.sidebarProps?.displayText,
            path: child.path,
          };
        }
      }

      if (child.children?.length) {
        const found = searchChild(child, childDisplayText);
        if (found) {
          if ("showRawText" in node.sidebarProps === false) {
            const response = {
              displayText: t(`SIDEBAR.${node.sidebarProps?.displayText}`),
              path: node.path,
            };
            return response;
          } else {
            return {
              displayText: node.sidebarProps?.displayText,
              path: node.path,
            };
          }
        }
      }
    }

    return null;
  }

  let parentName: any = isLandingPage
    ? null
    : findParentDisplayText(modelData, name);
  console.log(parentName);

  // Get providers from Redux store
  const providers = useAppSelector(
    (state) => state.chatConversations.providers
  );

  // Filter sidebar data when providers change
  useEffect(() => {
    if (!modelData || modelData.length > 0) {
      if (isLandingPage && providers) {
        // Set the breadcrumbs and header for the landing page
        dispatch(setBreadCrumbs([{ displayText: "Models/Capabilities", path: "" }]));
        dispatch(setHeader("mySecurity AI Engine"));
        
        // Show only the sidebar items that match the providers (what the user has access to)
        const targetObjs = filterSidebarByProviders(
          sidebarData,
          otherRoutes,
          providers
        );

        setTargetSidebarObjects(targetObjs);
      } else {
        // console.log("ExpandedSideBarArea - modelData:", modelData);
        // console.log("ExpandedSideBarArea - name 1:", name);
        // Original behavior - filter by selected sidebar item
        let crumbs: any = [];
        if (Array.isArray(parentName)) {
          crumbs = [...parentName];
        } else {
          crumbs.push(parentName);
        }
        // console.log("ExpandedSideBarArea - name 2:", name);
        dispatch(setBreadCrumbs([...crumbs, { displayText: name, path: "" }]));

        // console.log("ExpandedSideBarArea - name 3:", name);
        dispatch(setHeader(name));

        // console.log("ExpandedSideBarArea - name 4:", name);

        let sublistValue = filterSubModels(modelData, [], name);

        // console.log("ExpandedSideBarArea - name 5:", name);

        // console.log("ExpandedSideBarArea - sublistValue:", sublistValue);
        //update Filter targetSidebarObjects
        let targetObjs = extractDisplayText(sublistValue[0]);
        setTargetSidebarObjects(targetObjs);
      }
    }
  }, [name, isLandingPage, modelData, providers]);

  return (
    <HomeContainer
      className={
        apptheme?.name === "dark-theme"
          ? "bg-gradient-to-b from-gray-900 to-black"
          : ""
      }
    >
      {targetSidebarObjects.length > 0 && (
        <FilteredItems
          tagsData={targetSidebarObjects}
          isLandingPage={isLandingPage}
        ></FilteredItems>
      )}
    </HomeContainer>
  );
}
export default ExpandedSideBarArea;
